<div
	class="code-editor-wrapper"
	#wrapper
	[class.code-editor-wrapper--fullscreen]="isFullscreen()"
>
	@if (isFullscreen()) {
		<div class="code-editor-fullscreen-header">
			<span class="code-editor-fullscreen-title">Code Editor</span>
			<button
				class="code-editor-close-btn"
				(click)="closeFullscreen()"
				title="Close fullscreen"
			>
				✕
			</button>
		</div>
	}

	@if (size() !== 'singleline') {
		<button
			class="code-editor-fullscreen-btn"
			(click)="openFullscreen()"
			title="Open fullscreen"
		>
			⛶
		</button>
	}
	<div [ngClass]="cssClasses()" #container></div>
</div>
